<template>
  <div class="w-full min-w-0">
    <div class="mx-0 w-full">
      <div class="mb-4 w-full bg-white shadow sm:mb-5 sm:rounded-lg md:mb-8">
        <LandingCardTitle
          :title="title"
          :view-all-to="viewAllTo"
          :variant
          v-if="title || $slots.title || $slots.titlePrefix || $slots.titleSuffix"
        >
          <slot name="title" v-if="$slots.title"></slot>
          <template #titlePrefix v-if="$slots.titlePrefix">
            <slot name="titlePrefix"></slot>
          </template>
          <template #titleSuffix v-if="$slots.titleSuffix">
            <slot name="titleSuffix"></slot>
          </template>
        </LandingCardTitle>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { LandingCardVariant } from "@/components/landing/landingCard";
import LandingCardTitle from "@/components/landing/LandingCardTitle.vue";
import { defineComponent, type PropType } from "vue";
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

export default defineComponent({
  name: "LandingCard",
  components: {
    LandingCardTitle,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    viewAllTo: {
      type: Object as PropType<string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric>,
      required: false,
      default: null,
    },
    variant: {
      type: String as PropType<LandingCardVariant>,
      required: false,
      default: "plain",
    },
  },
});
</script>
